/* eslint-disable @typescript-eslint/no-unused-vars */
/**
 * 延遲載入的 JavaScript
 *
 * 1. Advantech Live Chatbot
 */

export default defineNuxtPlugin(() => {
  const runtimeConfig = useRuntimeConfig();
  const { ENVIRONMENT } = runtimeConfig.public;
  const { $i18n, $pinia } = useNuxtApp();
  const mainStore = useMainStore($pinia);
  const { isLiveChatReady } = storeToRefs(mainStore);
  const { locale } = $i18n;
  const isCN = locale.value === EnumLocale.ZH_CN;

  const blobDomain = provideBlobDomain(
    locale.value as EnumLocale,
    ENVIRONMENT,
    true
  );

  // TODO: LiveChatbot 暫時隱藏

  const initLiveChatbot = (): void => {
    /**
     * * NOTE: 如果 JS 檔案有改動，請同步更新 integrity 的 SRI Hash
     * @see https://www.srihash.org/
     *
     * https://advcloudfiles.advantech.com/support/live-chat/1.6.0/dist/main.js
     * https://advcloudfiles.advantech.com/support/live-chat/1.6.0/dist/main.min.js
     */

    if (!isCN) {
      window.__AdvLiveChat_global__ = {
        department: 'Advantech-WISE-IoT_Chatbot',
      };
    }

    const script: HTMLScriptElement = document.createElement('script');

    script.src = `${blobDomain}/support/live-chat/1.6.0/dist/main.min.js`;
    script.async = false;
    script.defer = true;
    script.integrity =
      'sha384-QSEn6eHB02X8zWlFTIPTATDy1/b+G0vyMd2xtUL4ylim/YM9hbpPJ+it7OaCW1F4';
    script.crossOrigin = 'anonymous';

    document.body.appendChild(script);

    window.onAdvLiveChatReady = function () {
      isLiveChatReady.value = true;
    };
  };

  const init = (): void => {};

  if (window.addEventListener) {
    window.addEventListener('load', init, false);
  } else {
    window.onload = init;
  }
});
